import { __assign, __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import RoleService from '@/modules/auth/RoleService';
import AuthService from '@/modules/auth/AuthServices';
var role = {
  name: '',
  modules: [],
  description: ''
};

var RoleModel =
/** @class */
function (_super) {
  __extends(RoleModel, _super);

  function RoleModel() {
    var _this = _super.call(this, role, RoleService) || this;

    _this.modelName = 'Rol';
    _this.request = 'JSON';
    return _this;
  }

  RoleModel.prototype.mapRow = function (row) {
    return __awaiter(this, void 0, void 0, function () {
      var fetchedRow, complete, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.getBy({
              id: row.id,
              url: 'get',
              query: {}
            })];

          case 1:
            fetchedRow = _a.sent();
            complete = fetchedRow.complete, data = fetchedRow.data;

            if (complete) {
              _super.prototype.mapRow.call(this, __assign(__assign({}, data), {
                id: row.id
              }));
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  RoleModel.prototype.getPermissions = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.request({
              method: 'POST',
              query: data
            })];

          case 1:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , {
                data: response.data.results,
                total: response.data.total
              }];
            }

            return [2
            /*return*/
            , false];
        }
      });
    });
  };

  RoleModel.prototype.getModules = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , AuthService.request({
              method: 'POST',
              query: data
            })];

          case 1:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , {
                data: response.data.results,
                total: response.data.total
              }];
            }

            return [2
            /*return*/
            , false];
        }
      });
    });
  };

  return RoleModel;
}(BaseModel);

export default RoleModel;